// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608201634/js/" + chunkId + "." + {"44":"c783c714","225":"770ebc5e","481":"b3ecb28e","486":"12505ea6","770":"09ebc82d"}[chunkId] + ".0.46297047529994595.chunk.js";
};